import { createApi } from '@reduxjs/toolkit/query/react';

import type { ProductModelItem } from '@app/api/Products';
import { WAREHOUSES_RESOURCE } from '@app/constants';
import { customBaseQuery } from '@app/services/rtkQuery/baseQuery';
import { Methods } from '@app/services/rtkQuery/types';
import type {
  GetBranchWarehousesRequest,
  GetWarehouseById,
  GetWarehousesRequest,
  ModelWarehouse,
  ModelWarehousesSearchResult,
  SearchWarehousesRequest,
  UpdateWarehouseRequest,
} from '@app/services/rtkQuery/Warehouses/types';
import { WarehousesEndpoints as Endpoints } from '@app/services/rtkQuery/Warehouses/types';

export const warehousesApi = createApi({
  reducerPath: 'warehousesApi',
  baseQuery: ({ url, ...props }) =>
    customBaseQuery({ url: `${WAREHOUSES_RESOURCE}/${url}`, ...props }),
  endpoints: ({ query, mutation }) => ({
    [Endpoints.SearchWarehouses]: mutation<
      ModelWarehousesSearchResult,
      SearchWarehousesRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.SearchWarehouses,
        method: Methods.POST,
        params,
        data,
      }),
    }),

    [Endpoints.UpdateWarehouse]: mutation<
      ModelWarehouse,
      UpdateWarehouseRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.UpdateWarehouse,
        method: Methods.POST,
        params,
        data,
      }),
    }),

    [Endpoints.GetWarehouseById]: query<ModelWarehouse, GetWarehouseById>({
      query: (params) => ({
        url: Endpoints.GetWarehouseById,
        method: Methods.GET,
        params,
      }),
    }),

    [Endpoints.GetWarehouses]: query<
      Array<ModelWarehouse>,
      GetWarehousesRequest
    >({
      query: (params) => ({
        url: Endpoints.GetWarehouses,
        method: Methods.GET,
        params,
      }),
    }),

    [Endpoints.GetBranchWarehouses]: query<
      Array<ProductModelItem>,
      GetBranchWarehousesRequest
    >({
      query: (params) => ({
        url: Endpoints.GetBranchWarehouses,
        method: Methods.GET,
        params,
      }),
    }),

    [Endpoints.GetCurrentBranchWarehouses]: query<
      Array<ModelWarehouse>,
      GetWarehousesRequest
    >({
      query: (params) => ({
        url: Endpoints.GetCurrentBranchWarehouses,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useSearchWarehousesMutation,
  useUpdateWarehouseMutation,
  useLazyGetWarehouseByIdQuery,
  useGetWarehousesQuery,
  useGetBranchWarehousesQuery,
  useGetWarehouseByIdQuery,
  useLazyGetBranchWarehousesQuery,
  useLazyGetWarehousesQuery,
  useGetCurrentBranchWarehousesQuery,
  useLazyGetCurrentBranchWarehousesQuery,
} = warehousesApi;
